var path = 'areas/configuration/views/master_key_clippy.html';
var html = "<div ng-show=\"backup && !backup.IsMasterKeyBackedUp\"> <div class=\"alert alert-warning\"> <octo-clippy> <p class=strong> Hey there! Without a safe copy of your <strong>Octopus Master Key</strong>, it will be impossible to restore backups of your Octopus Deploy database on any other machine. Please <a href=http://g.octopushq.com/SaveMyMasterKey target=_blank>take a copy of your master key</a> and put it in a safe place. </p> <p> <button class=\"btn btn-success\" type=button ng-click=okayIveDoneThis()>OK, I've backed it up, stop reminding me</button> </p> </octo-clippy> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/views/master_key_clippy.html
// module id = 764
// module chunks = 1